<template>
  <div class="m-card">
    <b-row class="m-card-padding">
      <b-col cols="8">
        <span class="m-card-title"><slot name="title"></slot></span>
      </b-col>
      <b-col cols="4" style="text-align: right">
        <span class="m-card-sub-title">Qty Available</span>
      </b-col>
    </b-row>

    <b-row v-for="(item,index) in orders"
           :key="item.name" class="m-card-order-item">
      <b-col cols="2">
        <span class="m-card-month">{{ item.OrderDate | formatMonth}}</span><br>
        <span class="m-card-date">{{ item.OrderDate |  formatDay}}</span>
      </b-col>
      <b-col cols="5">
        <div class="m-card-order-item-title text-one-line">{{item.OrderDesc}}</div>
        <span class="box-subtitle text-one-line">{{states.dataSources[item.OrderType]}} List</span>
        <span class="box-subtitle text-one-line">{{item.OrderCode}}</span>
      </b-col>
      <b-col cols="5" style="text-align: right">
        <div class="m-card-order-item-qty">{{item.TotalAvailableQty | numberFormat('',0) }}</div>

        <a class="btn btn-outline-primary x-width"
           v-if="orderType === 'savedOrder'"
           :href="$store.getters['config/link']('getSavedCount')+item.SessionGuid"
        >
          Retrieve Counts
        </a>
        <div class="btn btn-outline-primary x-width"
             :class="{disabled: orderMoreDisabled(item)}"
             v-if="orderType === 'recentOrder'"
             @click = "orderMore(item)"
        >
          Order More
        </div>

      </b-col>
      <m-order-detail :order="item">

      </m-order-detail>
    </b-row>
    <b-row class="m-card-footer">
      <slot name="footer"></slot>
    </b-row>

  </div>
</template>

<script>
  import notificaton from '@/components/common/notification'
  import MOrderDetail from '@/components/landings/MOrderDetail'
  export default {
    components: {
      MOrderDetail
    },
    props: ['orders', 'orderType'],
    data: function () {
      return {
        states: this.$store.state.user,
        isOrdering: false
      }
    },
    methods: {
      orderMoreDisabled (item) {
        // let orderDate = new Date(parseInt(/-?\d+/.exec(item.OrderDate)[0]))
        // let today = new Date()
        // let day = today.getTime() - orderDate.getTime()
        // day = day / 64000000

        // return !(item.state === 75 && item.OnlineOrder && item.OrderType === 10 && !this.isOrdering && day<365)
        return item.OrderType !== 10
      },
      orderMoreError (resp) {
        this.isOrdering = false
        notificaton.notice('error', 'Please try again, or cantact us', {title: 'Order More Failed', onlyGroup: 'connectError'})
      },
      orderMore  (orderItem) {
        if (this.orderMoreDisabled(orderItem)) {
          return false
        } else {
          this.isOrdering = true
        }
        // utils.ga('getCount','goto')
        var that = this
        this.$http.post('rpt/MyOrdersHistory.aspx/GetOrderMoreByOrder', {
          orderId: orderItem.OrderId
        }).then(resp => {
          if (resp.body.d.ResultFlag) {
            var order = {
              SuppressionType: 2,
              // OrderSuppressions
              OrderSuppressions: [{
                SuppressedOrderId: orderItem.OrderId,
                SuppressionName: orderItem.OrderDesc,
                SuppressionValue: orderItem.OrderCode,
                OriginalOrderId: orderItem.OrderId,
                SuppressedOrderCode: orderItem.OrderCode,
                SuppressedOrderDesc: orderItem.OrderDesc
              }],
              ListType: orderItem.ListType,
              AccountId: resp.body.d.DataSource.AccountId
              // entity Order
            }
            if (order.ListType === 50) { // entity.enums.DataSourceType.Occupant
              order.OrderSuppressions = []
              order.SuppressionType = 0
            }
            that.submitOrderMore(order)
            return order
          } else {
            that.orderMoreError(resp)
          }
        }, resp => {
          that.orderMoreError(resp)
        })
      },
      submitOrderMore (order) {
        var that = this
        this.$http.post('rpt/MyOrdersHistory.aspx/SubmitForOrderMore', {
          order: order
        }).then(resp => {
          if (resp.body.d.ResultFlag) {
            this.isOrdering = false
            window.location.href = this.$store.getters['config/link']('getOrderMoreCountGo')
          } else {
            that.orderMoreError(resp)
          }
        }, resp => {
          that.orderMoreError(resp)
        })
      }
    }
  }
</script>

<style scoped>
  .m-card {
    margin-top: 24px;
    background-color: #fff;
    padding: 24px;
    font-size: 0.9em;
    min-height: 240px;
    border: 1px solid #B0B0B0;
    border-radius: 4px;
    padding-top: 20px;
    padding-bottom: 0;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
  }


  .m-card-title {
    /*font-size: 1em;*/
    color: #000;
    font-size: 18px;
    /*font-weight: 600;*/
  }

  .m-card-sub-title{
    font-size: 13px;
    color: #000;
    text-align: right;
  }

  .m-card-month {
    font-size: 18px;
    color: #B0B0B0;
  }

  .m-card-date {
    font-size: 20px;
    color: #6A6A6A;
  }
  .m-card-order-item{
    min-height: 70px;
    margin-left: -24px;
    margin-right: -24px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    position: relative;
  }

  .m-card-order-item:hover {
    /* hover: */

    background: rgba(194, 194, 194, 0.09);
    /* Rectangle 6: */
    cursor: pointer;
  }


  .m-card-footer {
    text-align: center;
    border-top: 1px solid #F5F6FA;
    justify-content: center;
    font-size: 1em;
    margin-bottom: -15px;
    padding-top: 10px;
    margin-top: 10px;
  }

  .m-card-order-item-title {
    font-size: 17px;
    color: #333;
  }
  .m-card-order-item-qty{
    text-align: right;
  }
  .m-card-order-item:hover .m-order-detail {
    display: block;
  }

  .text-one-line {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .m-card-order-item-title {
    font-size: 17px;
    color: #000;
  }
  .m-card-order-item-qty{
    text-align: right;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    font-size: 14px;
  }
  .m-card-order-item:hover .m-order-detail {
    display: block;
  }

  .x-width {
    white-space: nowrap;
    padding: 5px 5px!important;
    text-transform: uppercase!important;
    font-weight: 700;
  }
  .btn-outline-primary:hover { background-color: #e04557!important; color: #FFFFFF!important;border-color: #e04557!important; }
  .btn-outline-primary.disabled {
    color: #6A6A6A;
    background-color: #f7d2c5!important;
  }
  .box-subtitle {
    color: #B0B0B0;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MCardOrder.vue